import { useFullStory } from "#webapp/src/util/fullstory";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import AIChatPlusCalendar from "../components/chat-plus-calendar/AIChatPlusCalendar";
import { useRedirectedFromPlanner } from "../components/web-app-calendar/hooks/usePlannerToAIRedirect";
import { page, PageEvents } from "../util/analytics.util";

const AIPage = () => {
  const { identify } = useFullStory();

  useEffect(() => {
    page(PageEvents.AI_PAGE);
  }, []);

  useEffect(() => {
    identify();
  }, [identify]);

  // TODO: Cleanup after Planner deprecation: https://linear.app/getclockwise/issue/AI-5329/remove-planner-from-nav-bar
  useRedirectedFromPlanner();

  return (
    <>
      <Helmet>
        <title>Prism · Clockwise</title>
      </Helmet>
      <div className="cw-w-full">
        <AIChatPlusCalendar />
      </div>
    </>
  );
};

export default AIPage;
